import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';
import { CommonModule } from '@angular/common';
import { AccountService } from 'src/services/data/account/account.service';
import { Response } from 'src/services/classes/models/response.interface';
import { Logger } from 'src/services/core/logger/logger.service';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { BaseButtonComponent } from 'src/app/shared/base-button/base-button.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseNameAvatarComponent } from 'src/app/shared/base-name-avatar/base-name-avatar.component';

const log = new Logger('Edit Profile');

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    BaseNameAvatarComponent,
    BaseButtonComponent,
  ],
})
export class EditProfileComponent implements OnInit {
  profileForm!: FormGroup;
  profileInfo: any;
  imageSet = false;

  constructor(
    private notifyService: NotificationsService,
    private accountService: AccountService,
    private fb: FormBuilder,
    private credentialsService: CredentialsService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.initProfileForm();
    this.getAndPrefillProfileInformation();
    this.profileInfo = this.credentialsService.credentials;
  }

  initProfileForm() {
    const emailPattern =
      '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$';

    this.profileForm = this.fb.nonNullable.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      image: [''],
      email: [
        '',
        [
          Validators.email,
          Validators.required,
          Validators.pattern(emailPattern),
        ],
      ],
    });
  }

  submitChanges() {
    this.profileForm.controls['email'].enable();
    const payload = this.assignFormDataValues(this.profileForm);
    this.updateAccountInformation(payload);
  }

  updateAccountInformation(payload: any) {
    const info$ = this.accountService.updateProfile(payload);
    info$.subscribe({
      next: (res: Response) => {
        if (res.status.toLowerCase() === 'success') {
          if (res.data) {
            const credentials = {
              ...this.credentialsService.credentials,
              ...res.data,
            };
            this.credentialsService.setCredentials(credentials);
          }

          res?.message
            ? this.notifyService.publishMessages(res.message, 'success', 1)
            : this.notifyService.publishMessages(
                'Profile updated successfully',
                'success',
                1
              );

          this.profileForm.controls['email'].disable();
          this.activeModal.close(res.status);
        } else {
          this.profileForm.controls['email'].disable();
          res?.message
            ? this.notifyService.publishMessages(res.message, 'danger', 1)
            : this.notifyService.publishMessages(
                'An error occurred',
                'danger',
                1
              );
        }
      },
      error: (error: any) => log.debug('error: ', error),
    });
  }

  getAndPrefillProfileInformation() {
    const profileInformation = this.credentialsService.credentials;
    if (profileInformation) {
      this.profileForm.patchValue({
        firstName: profileInformation?.firstName,
        lastName: profileInformation?.lastName,
        email: profileInformation?.email,
      });

      this.profileForm.controls['email'].disable();
    }
  }

  handleImgUpload(event: any) {
    log.debug('ev: ', event);
    this.imageSet = true;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      log.debug('file: ', file);
      this.profileForm.patchValue({
        image: file,
      });
      const holder: any = document.getElementById('new_pic');
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          holder.src = reader.result;
        },
        false
      );
      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  assignFormDataValues(form: FormGroup) {
    const formData = new FormData();
    Object.keys(form.controls).forEach((key) => {
      formData.append(key, form.value[key]);
    });
    return formData;
  }
}
